export const ToastMessages = {
  //Success
  CREATED: ':name :screen is created',
  DELETED: ':name :screen is deleted',
  UPDATED: ':name :screen is updated',
  PUBLISH: 'Changes are saved and api is published',
  //Failure
  FAILED_CREATED: ':screen creation is failed',
  FAILED_DELETED: ':screen deletion is failed',
  FAILED_UPDATED: ':screen updation is failed',
  PUBLISH_FAILED: 'Changes are saved and api publishing failed',
  //Mapping
  MAPPING_FAILED_ADDED: "Mapping'(s) addition is failed",
  MAPPING_FAILED_REMOVED: "Mapping'(s) removed is failed",
  MAPPING_ADDED: "Mapping'(s) addition is successful",
  MAPPING_REMOVED: "Mapping'(s) removed is successful",
  SUBSCRIPTION_ADDED: "Subscription'(s) added successfull",
  SUBSCRIPTION_FAILED_ADDED: "Subscription'(s) already present",
  SUBSCRIPTION_REMOVED: "Subscription'(s) removed successfull",
  SUBSCRIPTION_FAILED_REMOVED: "Subscription'(s) removed unsuccessfull",

  //User Constants
  LOCK_SUCCESS: ':name :screen is locked',
  LOCK_FAILED: ':screen is not locked',
  UNLOCK_SUCCESS: ':name :screen is unlocked',
  UNLOCK_FAILED: ':screen is not unlocked',
  SUSPEND_SUCCESS: ':name :screen is suspended',
  SUSPEND_FAILED: ':screen is not suspended',
  UNSUSPEND_SUCCESS: ':name :screen is unsuspended',
  UNSUSPEND_FAILED: ':screen is not unsuspended',
  RESET_PASS_SUCCESS: ':name :screen password is reset',
  RESET_PASS_FAILED: ':screen password not is reset',

  //Application Constants
  CLIENT_SUCCESS: 'Application Key Retrieved Succesfully',
  CLIENT_FAILED: 'Error in Application Key Retrieval',
  TOKEN_SUCCESS: 'Token Generated Succesfully',
  TOKEN_FAILED: 'Error in Generating Token',

  APPLICATION_CREATION_SUCCESS: 'Application Created Successfully',
  APPLICATION_CREATION_FAILED: 'Error in Generating Application',
  ROLE_DELETED: 'Role Deleted Successfully',
  ROLE_DELETED_FAILED: 'Role Deletion Failed',
  RESOURCE_DELETED_FAILED: 'Resource Deletion Failed',
  COMPONENT_DELETED_FAILED: 'Component Deletion Failed',
  RESOURCE_DELETED: 'Resource Deleted Successfully',
  COMPONENT_DELETED: 'Component Deleted Successfully',
  COMPONENT_RESOURCES_DELETED: 'Component Resource is Deleted Successfully',
  COMPONENT_RESOURCES_SUCCESS: 'Component Resource is Created Successfully',

  ROLE_UPLOAD: 'Role File Uploaded Successfully',
  RESOURCES_UPLOAD: 'Resources File Uploaded Successfully',
  COMPONENT_UPLOAD: 'Component File Uploaded Successfully',
};

export const ScreenMapping = {
  DOMAIN: 'Domain',
  ORGANIZATION: 'Organization',
  PERMISSION: 'Permission',
  ROLE: 'Role',
  USER: 'User',
  GROUP: 'Group',
  APPLICATION: 'Application',
  PUBLISHER: 'API',
  SUBSCRIBER: 'Subscriber',
  AUTHENTICATION: 'Authentication',
  PASSWORD: 'Password',
  RESOURCE: 'Resource',
  COMPONENT: 'Component',
  COMPONENTRESOURCE: 'Component Resource Mapping',
};
